import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { PartnerProfileData } from '../_lib/partner-server';
import { PartnerIntro } from './partner-intro';
type PartnerHeaderProps = {
  partner: PartnerProfileData;
};
export function PartnerHeader(t0) {
  const $ = _c(18);
  const {
    partner
  } = t0;
  const cover = partner.galleryImages[0] ?? partner.profileImage;
  const portrait = partner.profileImage;
  let t1;
  if ($[0] !== cover.alt || $[1] !== cover.url) {
    t1 = <div className="absolute -top-6 -left-4 xs:-left-6 h-[225px] w-[calc(100%+32px)] xs:w-[calc(100%+48px)] overflow-hidden sm:top-0 sm:left-8 sm:h-[234px] sm:w-[calc(100%-32px)] sm:rounded-xl md:left-[50px] md:h-[278px] md:w-[calc(100%-50px)]"><Image src={cover.url} alt={cover.alt} fill={true} className="object-cover" sizes="(min-width: 1260px) 1070px, (min-width: 1024px) calc(100vw - 146px), (min-width: 768px) calc(100vw - 80px), 100vw" priority={true} /></div>;
    $[0] = cover.alt;
    $[1] = cover.url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== portrait.alt || $[4] !== portrait.url) {
    t2 = <div className="absolute top-[73px] left-0 size-[168px] overflow-hidden rounded-xl shadow-elevation3 sm:top-[172px] sm:shadow-elevation4 md:top-[149px] md:size-[255px]"><Image src={portrait.url} alt={portrait.alt} fill={true} className="object-cover" sizes="(min-width: 1024px) 255px, 168px" /></div>;
    $[3] = portrait.alt;
    $[4] = portrait.url;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="relative h-[241px] sm:h-[340px] md:h-[404px]">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== partner.city || $[10] !== partner.experienceCount || $[11] !== partner.memberSince || $[12] !== partner.name || $[13] !== partner.tagline) {
    t4 = <div className="mt-4 sm:absolute sm:top-[255px] sm:left-[196px] sm:mt-0 sm:w-[534px] md:top-[300px] md:left-[289px] md:w-[635px]"><PartnerIntro tagline={partner.tagline} city={partner.city} name={partner.name} memberSince={partner.memberSince} experienceCount={partner.experienceCount} /></div>;
    $[9] = partner.city;
    $[10] = partner.experienceCount;
    $[11] = partner.memberSince;
    $[12] = partner.name;
    $[13] = partner.tagline;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <header className="fluid-container pt-6 sm:pt-5 md:pt-6"><div className="relative mx-auto max-w-[1120px]">{t3}{t4}</div></header>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}